import {
    TestingDetailState,
    initialTestingDetailState,
} from "@/mk2/apps/testings/containers/TestingDetail/TestingDetail.reducers";
import { AppState } from "@/mk2/reducers";

export const getTestingDetailState = (
    state: AppState,
    testingHashtag: string,
): TestingDetailState => {
    if (!state.containers.testings.testingDetail[testingHashtag]) {
        return initialTestingDetailState;
    }

    return state.containers.testings.testingDetail[testingHashtag];
};
